console.log("uga-choixparprofils.js");
/**
 * Choix par profils : "Vous êtes" > "Vous souhaitez" > bouton "Valider"
 * Version vanilla JS (sans jQuery) : desktop + mobile.
 * Tout le code est contenu dans la fonction choixParProfils() ; aucune autre fonction globale n'est créée.
 *
 * Attend dans le HTML :
 *   <div class="choix-profils"> <div class="plan-site"> <ul class="plan-site__1"> ... </ul> </div> </div>
 * (niveau 1 = profils, niveau 2 = actions avec leur lien)
 *
 * Libellés : variables de langue du site via __('texteVousEtes'), __('texteVousRecherchez'), __('texteValider').
 * Le script ne fait rien si la page ne contient aucun .choix-profils ; s'il y en a plusieurs, chacun est traité séparément.
 */
function choixParProfils() {
  'use strict';

  // Libellés (variables de langue du site) : renseignés une fois le test de présence passé
  let texteVousEtes;
  let texteVousRecherchez;
  let texteValider;

  // Vues selon la largeur du conteneur .card (mêmes seuils qu'avant)
  const VUES = [
    { max: 768, name: 'mini' },
    { max: 992, name: 'moyenne' },
    { max: 1366, name: 'grande' },
    { max: 1920, name: 'large' },
  ];

  // Mobile (vue "mini") : marge en haut de l'écran quand on cale un champ (augmenter si header sticky)
  const SCROLL_OFFSET = 16;
  // Mobile : marge en bas de l'écran sous la liste ouverte
  const MARGE_BAS = 16;

  // Icône de dépliage affichée dans les en-têtes actifs
  const ICON_HREF = '/static/icons/uga.svg#icon-depliage';
  const SVG_NS = 'http://www.w3.org/2000/svg';

  let uid = 0;

  /* ---------- utilitaires DOM ---------- */

  function choixParProfilsCreerElement(tag, className, attrs) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (attrs) Object.entries(attrs).forEach(([k, v]) => node.setAttribute(k, v));
    return node;
  }

  function choixParProfilsBasculerClasses(node, add, remove) {
    remove.forEach((c) => node.classList.remove(c));
    add.forEach((c) => node.classList.add(c));
  }

  /** Lit l'arbre du plan de site : [{ label, href, children: [{ label, href }] }] */
  function choixParProfilsLireArbre(tree) {
    const readLink = (a) => ({ label: a.textContent.trim(), href: a.getAttribute('href') });
    return Array.from(tree.children)
      .filter((li) => li.tagName === 'LI')
      .map((li) => {
        const a = li.querySelector(':scope > .plan-site__rubrique > a');
        if (!a) return null;
        const children = Array.from(
          li.querySelectorAll(':scope > ul > li > .plan-site__rubrique > a')
        ).map(readLink);
        return Object.assign(readLink(a), { children });
      })
      .filter(Boolean);
  }

  /** En-tête cliquable (h3) avec libellé + flèche */
  function choixParProfilsCreerEnTete(className, text, controlsId) {
    const h3 = choixParProfilsCreerElement('h3', className, {
      role: 'button',
      tabindex: '0',
      'aria-haspopup': 'listbox',
      'aria-expanded': 'false',
      'aria-controls': controlsId,
    });
    const libelle = choixParProfilsCreerElement('span', 'choix-libelle');
    libelle.textContent = text;
    h3.append(libelle);
    return h3;
  }

  /** Ajoute ou retire l'icône de dépliage dans l'en-tête (présente uniquement quand il est actif) */
  function choixParProfilsBasculerIcone(head, on) {
    let svg = head.querySelector('svg.icon-icon-depliage');
    if (!on) {
      if (svg) svg.remove();
      return;
    }
    if (svg) return;
    svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('class', 'icon icon-icon-depliage icon--sm');
    svg.setAttribute('aria-hidden', 'true');
    const title = document.createElementNS(SVG_NS, 'title');
    const use = document.createElementNS(SVG_NS, 'use');
    use.setAttribute('href', ICON_HREF);
    svg.append(title, use);
    head.append(svg);
  }

  /** Remplit une <ul> d'options ; la 1re est le "placeholder" (indefini) qui permet de revenir en arrière */
  function choixParProfilsRemplirListe(ul, placeholderText, items) {
    ul.replaceChildren();
    const make = (text, href, extraClass, index) => {
      const li = choixParProfilsCreerElement('li', extraClass || '', { role: 'presentation' });
      const span = choixParProfilsCreerElement('span', 'plan-site__rubrique');
      const a = choixParProfilsCreerElement('a', '', { href: href || '#', role: 'option' });
      a.textContent = text;
      if (index !== undefined) li.dataset.index = String(index);
      span.append(a);
      li.append(span);
      return li;
    };
    ul.append(make(placeholderText, '#', 'indefini item-actif'));
    items.forEach((item, i) => ul.append(make(item.label, item.href, '', i)));
  }

  /* ---------- composant ---------- */

  function choixParProfilsInitialiser(root) {
    const tree = root.querySelector('.plan-site__1');
    if (!tree) return;
    const data = choixParProfilsLireArbre(tree);
    const id = ++uid;

    /* Construction du DOM */
    const list1 = choixParProfilsCreerElement('ul', 'plan-site__1 invisible', { id: `choix-liste-1-${id}`, role: 'listbox' });
    const list2 = choixParProfilsCreerElement('ul', 'mes-choix invisible', { id: `choix-liste-2-${id}`, role: 'listbox' });
    choixParProfilsRemplirListe(list1, texteVousEtes, data);
    choixParProfilsRemplirListe(list2, texteVousRecherchez, []);

    const head1 = choixParProfilsCreerEnTete('vousetes bg__blanc', texteVousEtes, list1.id);
    const head2 = choixParProfilsCreerEnTete('vousrecherchez bg__gris__clair', texteVousRecherchez, list2.id);
    head2.setAttribute('aria-disabled', 'true');
    head2.setAttribute('tabindex', '-1');
    choixParProfilsBasculerIcone(head1, true);   // "Vous êtes" est actif dès le départ
    choixParProfilsBasculerIcone(head2, false);  // "Vous souhaitez" est verrouillé

    const submit = choixParProfilsCreerElement('a', 'action-submit bg__gris', { role: 'link', 'aria-disabled': 'true' });
    submit.textContent = texteValider;

    const choix1 = choixParProfilsCreerElement('div', 'choix-1');
    const choix2 = choixParProfilsCreerElement('div', 'choix-2');
    const choix3 = choixParProfilsCreerElement('div', 'choix-3');
    choix1.append(head1, list1);
    choix2.append(head2, list2);
    choix3.append(submit);
    root.replaceChildren(choix1, choix2, choix3);

    /* --- Ouverture / fermeture --- */
    const card = root.closest('.card');
    const isMini = () => !!card && card.classList.contains('choix-profils__vue__mini');
    const scrollBehavior = () =>
      window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

    /**
     * Mobile : la liste s'affiche en superposition sous son en-tête (voir le CSS mobile).
     * On cale l'en-tête en haut de l'écran et on limite la hauteur de la liste
     * à l'espace visible ; la liste défile en interne si besoin.
     */
    const positionList = (head, list, open) => {
      if (!open || !isMini()) {
        list.style.removeProperty('max-height');
        return;
      }
      const vh = window.visualViewport ? window.visualViewport.height : window.innerHeight;
      const dispo = vh - SCROLL_OFFSET - head.offsetHeight - MARGE_BAS;
      list.style.maxHeight = Math.max(dispo, 120) + 'px';
      const delta = head.getBoundingClientRect().top - SCROLL_OFFSET;
      if (Math.abs(delta) > 4) window.scrollBy({ top: delta, behavior: scrollBehavior() });
    };

    const setOpen = (head, list, open) => {
      list.classList.toggle('invisible', !open);
      list.classList.toggle('transition', open);
      head.setAttribute('aria-expanded', String(open));
      positionList(head, list, open);
    };
    const isOpen = (list) => !list.classList.contains('invisible');
    const closeAll = () => {
      setOpen(head1, list1, false);
      setOpen(head2, list2, false);
    };
    const isLevel2Locked = () => !choix2.classList.contains('choix-valide');

    /* --- Bouton Valider --- */
    const setSubmit = (href) => {
      if (href) {
        submit.setAttribute('href', href);
        submit.removeAttribute('aria-disabled');
        submit.classList.remove('bg__gris');
        choix3.classList.add('choix-valide');
      } else {
        submit.removeAttribute('href');
        submit.setAttribute('aria-disabled', 'true');
        submit.classList.add('bg__gris');
        choix3.classList.remove('choix-valide');
      }
    };
    submit.addEventListener('click', (e) => {
      if (submit.getAttribute('aria-disabled') === 'true') e.preventDefault();
    });

    /* --- Niveau 2 : verrouillage / déverrouillage --- */
    const resetLevel2 = (unlockWith) => {
      head2.querySelector('.choix-libelle').textContent = texteVousRecherchez;
      setSubmit(null);
      if (unlockWith) {
        choixParProfilsRemplirListe(list2, texteVousRecherchez, unlockWith);
        choix2.classList.add('choix-valide');
        choixParProfilsBasculerClasses(head2, ['bg__blanc'], ['bg__gris__clair']);
        head2.setAttribute('aria-disabled', 'false');
        head2.setAttribute('tabindex', '0');
        choixParProfilsBasculerIcone(head2, true);
      } else {
        choixParProfilsRemplirListe(list2, texteVousRecherchez, []);
        choix2.classList.remove('choix-valide');
        choixParProfilsBasculerClasses(head2, ['bg__gris__clair'], ['bg__blanc']);
        head2.setAttribute('aria-disabled', 'true');
        head2.setAttribute('tabindex', '-1');
        choixParProfilsBasculerIcone(head2, false);
      }
    };

    /**
     * Après un choix, l'utilisateur est replacé sur l'élément suivant (liste fermée) :
     * focus + scroll centré sur mobile, focus seul sur desktop.
     */
    const goToNext = (nextEl) => {
      if (!nextEl) return;
      if (isMini()) {
        nextEl.focus({ preventScroll: true });
        nextEl.scrollIntoView({ block: 'center', behavior: scrollBehavior() });
      } else {
        nextEl.focus();
      }
    };

    /* --- Événements --- */
    const toggleHead = (head, list, other, otherList) => {
      setOpen(other, otherList, false);
      setOpen(head, list, !isOpen(list));
    };

    head1.addEventListener('click', () => toggleHead(head1, list1, head2, list2));
    head2.addEventListener('click', () => {
      if (isLevel2Locked()) return;
      toggleHead(head2, list2, head1, list1);
    });

    [head1, head2].forEach((head) => {
      head.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') {
          e.preventDefault();
          head.click();
          const first = head.nextElementSibling.querySelector('a');
          if (isOpen(head.nextElementSibling) && first) first.focus({ preventScroll: true });
        }
      });
    });

    // Choix niveau 1
    list1.addEventListener('click', (e) => {
      const a = e.target.closest('a');
      if (!a) return;
      e.preventDefault();
      const li = a.closest('li');
      head1.querySelector('.choix-libelle').textContent = a.textContent.trim();
      list1.querySelectorAll('li').forEach((n) => n.classList.toggle('item-actif', n === li));

      const isPlaceholder = li.classList.contains('indefini');
      resetLevel2(isPlaceholder ? null : data[Number(li.dataset.index)].children);
      setOpen(head1, list1, false);
      goToNext(isPlaceholder ? head1 : head2);
    });

    // Choix niveau 2
    list2.addEventListener('click', (e) => {
      const a = e.target.closest('a');
      if (!a) return;
      e.preventDefault();
      const li = a.closest('li');
      head2.querySelector('.choix-libelle').textContent = a.textContent.trim();
      list2.querySelectorAll('li').forEach((n) => n.classList.toggle('item-actif', n === li));
      setSubmit(li.classList.contains('indefini') ? null : a.getAttribute('href'));
      setOpen(head2, list2, false);
      goToNext(li.classList.contains('indefini') ? head2 : submit);
    });

    // Navigation clavier dans les listes
    [list1, list2].forEach((list) => {
      list.addEventListener('keydown', (e) => {
        const links = Array.from(list.querySelectorAll('a'));
        const i = links.indexOf(document.activeElement);
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          links[Math.min(i + 1, links.length - 1)].focus();
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          links[Math.max(i - 1, 0)].focus();
        }
      });
    });

    // Échap et clic extérieur
    root.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      const openHead = isOpen(list1) ? head1 : isOpen(list2) ? head2 : null;
      closeAll();
      if (openHead) openHead.focus();
    });
    document.addEventListener('click', (e) => {
      if (!root.contains(e.target)) closeAll();
    });
    // Rotation / redimensionnement : on recalcule la hauteur de la liste ouverte
    window.addEventListener('resize', () => {
      if (isOpen(list1)) positionList(head1, list1, true);
      if (isOpen(list2)) positionList(head2, list2, true);
    });

    /* --- Vue selon la largeur de la .card --- */
    if (card) {
      const applyView = () => {
        const w = card.getBoundingClientRect().width;
        const vue = VUES.find((v) => w < v.max) || VUES[VUES.length - 1];
        VUES.forEach((v) => card.classList.toggle(`choix-profils__vue__${v.name}`, v === vue));
      };
      applyView();
      if ('ResizeObserver' in window) new ResizeObserver(applyView).observe(card);
      else window.addEventListener('resize', applyView);
    }

    // Le composant était masqué (display:none inline) le temps de la transformation
    root.style.removeProperty('display');
    if (!root.getAttribute('style')) root.removeAttribute('style');

    // Vue spéciale hauteur limitée
    if (root.classList.contains('choix-profils-hauteur-limitee')) {
      const ligne = root.closest('.skin_fo_unique__ligne');
      if (ligne) ligne.classList.add('ligne__choix-profils-hauteur-limitee');
    }
  }

  /* ---------- démarrage ---------- */

  // Le script ne s'exécute que si la page contient au moins un .choix-profils
  const composants = document.querySelectorAll('.choix-profils');
  if (!composants.length) return;

  // libelles appelés
  texteVousEtes = __('texteVousEtes');
  texteVousRecherchez = __('texteVousRecherchez');
  texteValider = __('texteValider');

  // Chaque .choix-profils de la page est traité indépendamment
  composants.forEach(choixParProfilsInitialiser);
}

// Lancement une fois le DOM prêt
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', choixParProfils);
else choixParProfils();